import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { RotatingLines } from "react-loader-spinner";
import { toast } from "react-toastify";
import "bootstrap/dist/css/bootstrap.min.css";
import "../Dashborad/dashboard.css";
import "react-image-crop/dist/ReactCrop.css";
import { doctorAllAppointment } from "../../config/service";
import DoctorFuture from "./DoctorFuture";
import DoctorPast from "./DoctorPast";
import DoctorPending from "./DoctorPending";
import DoctorRX from "./DoctorRx";

const DoctorDashboard = (props) => {
  const { subscriptionsList } = props
  const { t } = useTranslation();
  const lang = typeof window !== "undefined" && localStorage ? localStorage.getItem("lang") : null;
  const status = typeof window !== "undefined" && localStorage ? localStorage.getItem("status") : null;
  const [allAppointment, setAllAppointment] = useState([]);
  const [dateoffer, setdateoffer] = useState([]);
  const [meetingValue, setMeetingValue] = useState("");
  const [tabClick, setTabClick] = useState(false);
  const [newOfferDate, setNewOfferDate] = useState([]);
  const [offerModal, setOfferModal] = useState(false);
  const [medicalq, setMedicalQ] = useState(false);
  const [qData, setQData] = useState();
  const [comentModal, setCommentModal] = useState(false);
  const [loader, setLoader] = useState(true);
  const [updateLoader, setUpdateLoader] = useState(false);
  const [fdate, setFDate] = useState();
  const [sdate, setSDate] = useState();
  const [ftime, setFTime] = useState();
  const [stime, setSTime] = useState();
  const [startDate, setStartDate] = useState(new Date());
  const [startDate1, setStartDate1] = useState(new Date());
  const [note, setNote] = useState("");
  const [onlyRx, setOnlyRx] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");
  const [searchDebounce, setSearchDebounce] = useState("");
  const [rxSearchName, setRxSearchName] = useState("");
  const [rxSearchNameDebounce, setRxSearchNameDebounce] = useState("");
  const [rxSearchId, setRxSearchId] = useState("");
  const [rxSearchIdDebounce, setRxSearchIdDebounce] = useState("");
  const [rxSearchAge, setRxSearchAge] = useState("");
  const [rxSearchAgeDebounce, setRxSearchAgeDebounce] = useState("");
  const [rxSearchOriginalValue, setRxSearchOriginalValue] = useState(""); // Store original search value
  const [pastSearchName, setPastSearchName] = useState("");
  const [pastSearchNameDebounce, setPastSearchNameDebounce] = useState("");
  const [pastSearchId, setPastSearchId] = useState("");
  const [pastSearchIdDebounce, setPastSearchIdDebounce] = useState("");
  const [pastSearchAge, setPastSearchAge] = useState("");
  const [pastSearchAgeDebounce, setPastSearchAgeDebounce] = useState("");
  const [pastSearchOriginalValue, setPastSearchOriginalValue] = useState("");
  /** YYYY-MM-DD for API body `from` / `to` on past tab */
  const [pastDateFrom, setPastDateFrom] = useState("");
  const [pastDateTo, setPastDateTo] = useState("");

  const handlePastDateRangeChange = (fromStr, toStr) => {
    setPastDateFrom(fromStr || "");
    setPastDateTo(toStr || "");
  };

  const handleClose = () => (
    setOfferModal(false),
    setNewOfferDate([]),
    setSearchQuery(""),
    setSearchDebounce(""),
    AllApoinmentDoctor({ val: "Created", search: "" }),
    datesOfferByDoctor({ val: "DatesOffered" }),
    setSDate(),
    setFDate(),
    setFTime(),
    setSTime(),
    setStartDate(),
    setStartDate1(),
    setMeetingValue("Created")
  );
  const handleClose6 = () => (
    setMedicalQ(false),
    AllApoinmentDoctor({
      val: "past",
      search: "",
      name: pastSearchNameDebounce,
      id: pastSearchIdDebounce,
      age: pastSearchAgeDebounce,
      from: pastDateFrom,
      to: pastDateTo,
    }),
    setQData({}),
    setMeetingValue("past")
  );
  const handleClose1 = () => (
    setMedicalQ(false),
    setQData({}),
    setMeetingValue("future")
  );
  const handleClose2 = () => (
    setCommentModal(false),
    AllApoinmentDoctor({
      val: "past",
      search: "",
      name: pastSearchNameDebounce,
      id: pastSearchIdDebounce,
      age: pastSearchAgeDebounce,
      from: pastDateFrom,
      to: pastDateTo,
    }),
    setMeetingValue("past")
  );
  const handleClose3 = () => (
    setCommentModal(false),
    AllApoinmentDoctor({ val: "future", search: searchDebounce }),
    setMeetingValue("future")
  );
  const [open, setOpen] = useState(false);
  const handleCloseSummary = () => {
    setOpen(false);
    if (meetingValue === "Done") {
      AllApoinmentDoctor({
        val: meetingValue,
        search: "",
        name: rxSearchNameDebounce,
        id: rxSearchIdDebounce,
        age: rxSearchAgeDebounce
      });
    } else if (meetingValue === "past") {
      AllApoinmentDoctor({
        val: meetingValue,
        search: "",
        name: pastSearchNameDebounce,
        id: pastSearchIdDebounce,
        age: pastSearchAgeDebounce,
        from: pastDateFrom,
        to: pastDateTo,
      });
    } else {
      AllApoinmentDoctor({ val: meetingValue, search: searchDebounce });
    }
    setMeetingValue(meetingValue);
  };

  useEffect(() => {
    AllApoinmentDoctor({ val: "Created" });
    datesOfferByDoctor({ val: "DatesOffered" });
  }, []);
  const datesOfferByDoctor = async ({ val }) => {
    setLoader(true);
    const data = {
      meeting_status: val,
    };

    const response = await doctorAllAppointment(data);
    setdateoffer(response.data.result);
    setLoader(false);
  };
  const handleResetState = () => {
    setUpdateLoader(true);
    setTimeout(() => {
      setUpdateLoader(false);
    }, 1000);
  };

  const AllApoinmentDoctor = async ({ val, search = "", name = "", id = "", age = "", from = "", to = "", onComplete } = {}) => {
    setLoader(true);
    const data = {
      meeting_status: val,
      search: search,
      name: name,
      id: id,
      age: age,
    };
    if (val === "past") {
      data.from = from || "";
      data.to = to || "";
    }
    const response = await doctorAllAppointment(data);
    if (
      allAppointment.length < response.data.result.length &&
      val === meetingValue &&
      meetingValue === "future"
    ) {
      handleResetState();
    }
    setAllAppointment(response.data.result);
    setTabClick(false);
    setLoader(false);
    if (onComplete) {
      onComplete();
    }
  };
  const handleTabClick = (value) => {
    if (value === "future") {
      setAllAppointment([]);
    }
    setSearchQuery("");
    setSearchDebounce("");
    setRxSearchName("");
    setRxSearchNameDebounce("");
    setRxSearchId("");
    setRxSearchIdDebounce("");
    setRxSearchAge("");
    setRxSearchAgeDebounce("");
    if (value !== "past") {
      setPastDateFrom("");
      setPastDateTo("");
    }
    // Single fetch: useEffect below runs AllApoinmentDoctor when meetingValue / debounces update
    setMeetingValue(value);
    localStorage.setItem("status", value);
  };

  const hanldeMeetingValue = () => {
    switch (true) {
      case props.subscriptionsList.length === 1 &&
        props.subscriptionsList.includes("Rx"):
        setMeetingValue("Done");
        break;
      case meetingValue === "future":
        setMeetingValue("future");
        break;
      case meetingValue === "past":
        setMeetingValue("past");
        break;
      default:
        setMeetingValue("Created");
        break;
    }
  };
  useEffect(() => {
    if (
      status === "Rx" ||
      (meetingValue === "Done" && props.subscriptionsList?.includes("Rx"))
    ) {
      setSearchQuery("");
      setSearchDebounce("");
      setRxSearchName("");
      setRxSearchNameDebounce("");
      setRxSearchId("");
      setRxSearchIdDebounce("");
      setRxSearchAge("");
      setRxSearchAgeDebounce("");
      // Single fetch: main useEffect runs AllApoinmentDoctor for meeting_status Done
      setMeetingValue("Done");
    } else {
      hanldeMeetingValue();
    }
  }, [status, meetingValue, props.subscriptionsList]);

  const handleCheckOnlyRx = () => {
    if (subscriptionsList.length === 1 &&
      subscriptionsList.includes("Rx")) {
      setOnlyRx(true)
    }
  }

  useEffect(() => {
    handleCheckOnlyRx()
  }, [subscriptionsList])

  useEffect(() => {
    const timer = setTimeout(() => {
      setSearchDebounce(searchQuery);
    }, 500);

    return () => clearTimeout(timer);
  }, [searchQuery]);

  useEffect(() => {
    const timer = setTimeout(() => {
      setRxSearchNameDebounce(rxSearchName);
    }, 500);
    return () => clearTimeout(timer);
  }, [rxSearchName]);

  useEffect(() => {
    const timer = setTimeout(() => {
      setRxSearchIdDebounce(rxSearchId);
    }, 500);
    return () => clearTimeout(timer);
  }, [rxSearchId]);

  useEffect(() => {
    const timer = setTimeout(() => {
      setRxSearchAgeDebounce(rxSearchAge);
    }, 500);
    return () => clearTimeout(timer);
  }, [rxSearchAge]);

  useEffect(() => {
    const timer = setTimeout(() => {
      setPastSearchNameDebounce(pastSearchName);
    }, 500);
    return () => clearTimeout(timer);
  }, [pastSearchName]);

  useEffect(() => {
    const timer = setTimeout(() => {
      setPastSearchIdDebounce(pastSearchId);
    }, 500);
    return () => clearTimeout(timer);
  }, [pastSearchId]);

  useEffect(() => {
    const timer = setTimeout(() => {
      setPastSearchAgeDebounce(pastSearchAge);
    }, 500);
    return () => clearTimeout(timer);
  }, [pastSearchAge]);

  const parseSearchValue = (searchValue) => {
    if (!searchValue || !searchValue.trim()) {
      return { name: "", id: "", age: "", isValid: true };
    }

    const parts = searchValue.trim().split(/\s+/);
    let name = "";
    let id = "";
    let age = "";
    let isValid = true;

    for (const part of parts) {
      const isNumber = /^\d+$/.test(part);

      if (isNumber) {
        const length = part.length;
        if (length <= 2) {
          // Age/ID (1-2 digits) - treat as both
          if (age || id) {
            // Multiple short numeric values - invalid
            isValid = false;
            break;
          }
          age = part;
          id = part;
        } else if (length >= 3 && length <= 9) {
          // ID (3-9 digits)
          if (id) {
            // Multiple ID values - invalid
            isValid = false;
            break;
          }
          id = part;
        } else {
          // More than 9 digits - invalid
          isValid = false;
          break;
        }
      } else {
        // Check if it contains only letters (and possibly spaces/hyphens for names)
        const isText = /^[א-תa-zA-Z\s\-']+$/.test(part);
        if (isText) {
          // Name (text only)
          name = name ? `${name} ${part}` : part;
        } else {
          // Contains numbers and letters or special characters - invalid
          isValid = false;
          break;
        }
      }
    }

    return { name, id, age, isValid };
  };

  // Function to trigger search immediately (for button click)
  const handleRxSearchClick = (searchFields) => {
    const searchValue = searchFields.Name || searchFields.ID || searchFields.Age || "";

    setRxSearchOriginalValue(searchValue);
    const parsed = parseSearchValue(searchValue);

    if (!parsed.isValid) {
      toast.error(t("הוזנו ערכים לא חוקיים"), { toastId: "invalid-search-values" });
      return;
    }

    setRxSearchName(parsed.name);
    setRxSearchId(parsed.id);
    setRxSearchAge(parsed.age);
    setRxSearchNameDebounce(parsed.name);
    setRxSearchIdDebounce(parsed.id);
    setRxSearchAgeDebounce(parsed.age);
    // Single fetch: useEffect on rxSearch*Debounce runs AllApoinmentDoctor once
  };

  // Function to trigger search for Past appointments
  const handlePastSearchClick = (searchValue) => {
    setPastSearchOriginalValue(searchValue);
    const parsed = parseSearchValue(searchValue);

    if (!parsed.isValid) {
      toast.error(t("הוזנו ערכים לא חוקיים"), { toastId: "invalid-search-values-past" });
      return;
    }
    setPastSearchName(parsed.name);
    setPastSearchId(parsed.id);
    setPastSearchAge(parsed.age);
    setPastSearchNameDebounce(parsed.name);
    setPastSearchIdDebounce(parsed.id);
    setPastSearchAgeDebounce(parsed.age);
    // Single fetch: useEffect on pastSearch*Debounce runs AllApoinmentDoctor once
  };

  useEffect(() => {
    if (meetingValue) {
      if (meetingValue === "Done") {
        AllApoinmentDoctor({
          val: meetingValue,
          search: "",
          name: rxSearchNameDebounce,
          id: rxSearchIdDebounce,
          age: rxSearchAgeDebounce
        });
      } else if (meetingValue === "past") {
        AllApoinmentDoctor({
          val: meetingValue,
          search: "",
          name: pastSearchNameDebounce,
          id: pastSearchIdDebounce,
          age: pastSearchAgeDebounce,
          from: pastDateFrom,
          to: pastDateTo,
        });
      } else {
        AllApoinmentDoctor({ val: meetingValue, search: searchDebounce });
      }
    }
  }, [searchDebounce, rxSearchNameDebounce, rxSearchIdDebounce, rxSearchAgeDebounce, pastSearchNameDebounce, pastSearchIdDebounce, pastSearchAgeDebounce, pastDateFrom, pastDateTo, meetingValue]);

  return (
    <div className={`${onlyRx ? "only-rx-doc" : ""}`}>
      <section className="statusWrapper doctor-dashboard">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="innerWrapper">
                {props.subscriptionsList &&
                  props.subscriptionsList?.includes("Hidoc") && (
                    <>
                      {props.subscriptionsList?.includes("Rx") && (
                        <div
                          className={`${lang === "HE" ? "itemBoxHeb" : "itemBoxEng"
                            } ${meetingValue == "Done" ? "activeDashTab" : ""}`}
                          onClick={() => handleTabClick("Done")}
                        >
                          {lang === "HE" ? (
                            <h2>
                              {t("Clients")} <strong> {t("RX")}</strong>
                            </h2>
                          ) : (
                            <h2>
                              <strong> {t("RX")}</strong> {t("Clients")}
                            </h2>
                          )}
                        </div>
                      )}
                      <div
                        className={`${lang === "HE" ? "itemBoxHeb" : "itemBoxEng"
                          } ${meetingValue == "past" ? "activeDashTab" : ""}`}
                        onClick={() => handleTabClick("past")}
                      >
                        {lang === "HE" ? (
                          <h2>
                            {t("APPOINTMENTS")} <strong> {t("MY PAST")}</strong>
                          </h2>
                        ) : (
                          <h2>
                            <strong> {t("MY PAST")}</strong> {t("APPOINTMENTS")}
                          </h2>
                        )}
                      </div>
                      <div
                        className={`${lang === "HE" ? "itemBoxHeb" : "itemBoxEng"
                          } ${meetingValue == "Created" ? "activeDashTab" : ""}`}
                        onClick={() => handleTabClick("Created")}
                      >
                        {lang === "HE" ? (
                          <h2>
                            <strong>{t("MY PENDING REQUESTS")}</strong>
                            {t("REQUESTS")}
                          </h2>
                        ) : (
                          <h2>
                            <strong>{t("MY PENDING REQUESTS")}</strong>{" "}
                            {t("STATUS")}
                          </h2>
                        )}
                      </div>
                      <div
                        className={`${lang === "HE" ? "itemBoxHeb" : "itemBoxEng"
                          } ${meetingValue == "future" ? "activeDashTab" : ""}`}
                        onClick={() => handleTabClick("future")}
                      >
                        {lang === "HE" ? (
                          <h2>
                            {t("APPOINTMENTS")}{" "}
                            <strong> {t("MY FUTURE")}</strong>
                          </h2>
                        ) : (
                          <h2>
                            <strong> {t("MY FUTURE")}</strong>{" "}
                            {t("APPOINTMENTS")}
                          </h2>
                        )}
                      </div>
                    </>
                  )}
              </div>
            </div>
            <div className="col-lg-12">
              {updateLoader && meetingValue === "future" && !loader ? (
                <div className="futur-loader">
                  <RotatingLines
                    strokeColor="grey"
                    strokeWidth="5"
                    animationDuration="0.75"
                    width="48"
                    visible={updateLoader}
                  />
                </div>
              ) : null}
            </div>
          </div>
        </div>
      </section>
      {loader ? (
        <div style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          padding: '50px',
          minHeight: '300px'
        }}>
          <RotatingLines
            strokeColor="grey"
            strokeWidth="5"
            animationDuration="0.75"
            width="48"
            visible={loader}
          />
        </div>
      ) : (
        <>
          {meetingValue == "future" ? (
            <DoctorFuture
              allAppointment={allAppointment}
              handleClose5={handleClose1}
              medicalq={medicalq}
              setMedicalQ={setMedicalQ}
              qData={qData}
              setQData={setQData}
              handleClose3={handleClose3}
              comentModal={comentModal}
              setCommentModal={setCommentModal}
              loader={loader}
              handleCloseSummary={handleCloseSummary}
              open={open}
              setOpen={setOpen}
              meetingValue={meetingValue}
              tabClick={tabClick}
              setNote={setNote}
              note={note}
              searchQuery={searchQuery}
              setSearchQuery={setSearchQuery}
            />
          ) : meetingValue == "Created" ? (
            <DoctorPending
              allAppointment={allAppointment}
              newOfferDate={newOfferDate}
              offerModal={offerModal}
              handleClose={handleClose}
              setNewOfferDate={setNewOfferDate}
              setOfferModal={setOfferModal}
              loader={loader}
              dateoffer={dateoffer}
              fdate={fdate}
              setFDate={setFDate}
              sdate={sdate}
              setSDate={setSDate}
              ftime={ftime}
              setFTime={setFTime}
              stime={stime}
              setSTime={setSTime}
              startDate={startDate}
              setStartDate={setStartDate}
              startDate1={startDate1}
              setStartDate1={setStartDate1}
            />
          ) : meetingValue == "past" ? (
            <DoctorPast
              allAppointment={allAppointment}
              handleClose5={handleClose6}
              medicalq={medicalq}
              setMedicalQ={setMedicalQ}
              qData={qData}
              setQData={setQData}
              handleClose2={handleClose2}
              comentModal={comentModal}
              setCommentModal={setCommentModal}
              loader={loader}
              handleCloseSummary={handleCloseSummary}
              open={open}
              setOpen={setOpen}
              AllApoinmentDoctor={AllApoinmentDoctor}
              setMeetingValue={setMeetingValue}
              meetingValue={meetingValue}
              setNote={setNote}
              note={note}
              onSearchClick={handlePastSearchClick}
              originalSearchValue={pastSearchOriginalValue}
              pastDateFrom={pastDateFrom}
              pastDateTo={pastDateTo}
              onPastDateRangeChange={handlePastDateRangeChange}
            />
          ) : meetingValue == "Done" ||
            (meetingValue == "Done" && props.subscriptionsList?.includes("Rx")) ? (
            <DoctorRX
              allAppointment={allAppointment}
              handleCloseSummary={handleCloseSummary}
              open={open}
              setOpen={setOpen}
              AllApoinmentDoctor={AllApoinmentDoctor}
              setMeetingValue={setMeetingValue}
              meetingValue={meetingValue}
              onlyRx={onlyRx}
              onSearchUpdate={(searchFields) => {
                setRxSearchName(searchFields.Name || "");
                setRxSearchId(searchFields.ID || "");
                setRxSearchAge(searchFields.Age || "");
              }}
              onSearchClick={handleRxSearchClick}
              originalSearchValue={rxSearchOriginalValue}
              loader={loader}
            />
          ) : (
            <DoctorPast
              allAppointment={allAppointment}
              handleClose5={handleClose6}
              medicalq={medicalq}
              setMedicalQ={setMedicalQ}
              qData={qData}
              setQData={setQData}
              handleClose2={handleClose2}
              comentModal={comentModal}
              setCommentModal={setCommentModal}
              loader={loader}
              handleCloseSummary={handleCloseSummary}
              open={open}
              setOpen={setOpen}
              AllApoinmentDoctor={AllApoinmentDoctor}
              setMeetingValue={setMeetingValue}
              meetingValue={meetingValue}
              setNote={setNote}
              note={note}
              onSearchClick={handlePastSearchClick}
              originalSearchValue={pastSearchOriginalValue}
              pastDateFrom={pastDateFrom}
              pastDateTo={pastDateTo}
              onPastDateRangeChange={handlePastDateRangeChange}
            />
          )}
        </>
      )}

    </div>
  );
};
export default DoctorDashboard;
